module.exports = __webpack_public_path__ + "static/media/Office 365 Email Integration.1c873888.png";